import { Buttonv2 as Button } from 'schola-components';
import { t } from 'components/translation/Translation';
// styles
import styles from './login-signup-buttons.module.scss';

export const LoginSignupButtons = ({ showModalLogin, showModalSignUp }) => {
  return (
    <div className={styles.buttons}>
      <Button className={styles.button} color="secondary" onClick={showModalLogin} fullWidthMobile>
        {t('parent:layout.logIn')}
      </Button>
      <Button className={styles.button} color="primary" onClick={showModalSignUp} fullWidthMobile>
        {t('parent:layout.signUp')}
      </Button>
    </div>
  );
};
